var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "#DAC599",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.952 5.2a.536.536 0 0 1-.757 0L5.003 2.009 1.812 5.2a.536.536 0 1 1-.758-.758l3.57-3.57c.21-.21.549-.21.758 0l3.57 3.57c.21.21.21.549 0 .758",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;